module.exports = __webpack_public_path__ + "static/img/logo1@2x.6328e6d0.png";